// Supported res_types for quick-search-v2 and global-search-v2 APIs
export const SUPPORTED_RES_TYPES = [
  'case', // Cases (is_lead=false)
  'lead', // Leads (is_lead=true)
  'contact', // Contacts (from user with contact_type)
  'user', // Will be split to contact/firm_user (only contact indexed)
  'task', // Tasks
  'event', // Events/calendar
  'message', // Messages/emails
  'email_thread', // Email threads
  'file_system_entry', // Files/documents
  'case_note', // Case notes
  'case-note', // Case notes (alternate)
];

// Global Search constants
export const GLOBAL_SEARCH_FILTER_OPTIONS = [
  { label: 'Case Notes', value: 'case_note' },
  { label: 'Cases', value: 'cases' },
  { label: 'Contacts', value: 'contacts' },
  { label: 'Email Threads', value: 'email_threads' },
  { label: 'Events', value: 'events' },
  { label: 'Files', value: 'files' },
  { label: 'Leads', value: 'leads' },
  { label: 'Messages', value: 'messages' },
  { label: 'Tasks', value: 'task' },
  { label: 'Text Messages', value: 'text_messages' },
];

// Map UI filter to API modules string
export const GLOBAL_SEARCH_FILTER_TO_MODULES_MAP = {
  cases: 'case',
  leads: 'lead',
  contacts: 'contact',
  firm_users: 'firm_user',
  files: 'file_system_entry',
  events: 'event',
  messages: 'message, message-reply',
  email_threads: 'email_thread',
  text_messages: 'text_message_reply',
  task: 'task',
  invoice: 'invoice',
  payment_request: 'payment_request',
  case_note: 'case-note',
};

// Map UI filter to quick-search res_type (single value, not comma-separated)
export const GLOBAL_SEARCH_FILTER_TO_RES_TYPE_MAP = {
  cases: 'case',
  leads: 'lead',
  contacts: 'contact',
  files: 'file_system_entry',
  events: 'event',
  messages: 'message',
  email_threads: 'email_thread',
  text_messages: 'text_message_reply',
  task: 'task',
  case_note: 'case_note',
};

// Advanced Search constants
export const ADVANCED_SEARCH_ORDERED_LABELS = [
  'Contacts',
  'Cases',
  'Leads',
  'Files',
  'Events',
  'Messages',
  'Email Threads',
  'Text Messages',
  'Tasks',
  'Invoices',
  'Payment Request',
  'Case Notes',
  'Firm Users',
];

export const ADVANCED_SEARCH_NAV_TO_ADVANCED_MAP = {
  cases: 'cases',
  leads: 'leads',
  contacts: 'user',
  firm_users: 'firmUsers',
  files: 'file_system_entry',
  events: 'event',
  messages: 'message',
  email_threads: 'email_thread',
  text_messages: 'text_messages',
  case_note: 'case-note',
  task: 'task',
  invoice: 'invoice',
  payment_request: 'payment_request',
};

export const ADVANCED_SEARCH_ALL_CONTENT_TYPE_VALUES = [
  'cases',
  'case-note',
  'user',
  'event',
  'file_system_entry',
  'firmUsers',
  'invoice',
  'leads',
  'message',
  'payment_request',
  'task',
  'email_thread',
  'text_messages',
];

export const ADVANCED_SEARCH_CONTENT_TYPE_OPTIONS = [
  { label: 'Case Notes', value: 'case-note' },
  { label: 'Cases', value: 'cases' },
  { label: 'Contacts', value: 'user' },
  { label: 'Email Threads', value: 'email_thread' },
  { label: 'Events', value: 'event' },
  { label: 'Files', value: 'file_system_entry' },
  { label: 'Leads', value: 'leads' },
  { label: 'Messages', value: 'message' },
  { label: 'Tasks', value: 'task' },
  { label: 'Text Messages', value: 'text_messages' },
];

export const ADVANCED_SEARCH_FILE_TYPE_OPTIONS = [
  { label: 'DOC/DOCX', value: 'docx' },
  { label: 'Image', value: 'image' },
];

export const FILE_TYPE_TO_EXTENSIONS_MAP = {
  docx: 'pdf,doc,docx',
  image: 'jpg,jpeg,png,gif,webp',
};

export const ADVANCED_SEARCH_TIME_PERIOD_OPTIONS = [
  { label: 'All', value: 'all' },
  { label: 'Past Week', value: 'past_week' },
  { label: 'Past Month', value: 'past_month' },
  { label: 'Past 3 Months', value: 'past_quarter' },
  { label: 'Past Year', value: 'past_year' },
];

export const ADVANCED_SEARCH_SORT_BY_OPTIONS = [
  { label: 'Relevance', value: 'relevance' },
  { label: 'Created On', value: 'created_on' },
];

export const ADVANCED_SEARCH_MODULES_MAP = {
  cases: 'case',
  leads: 'lead',
  user: 'contact',
  firmUsers: 'firm_user',
  event: 'event',
  file_system_entry: 'file_system_entry',
  message: 'message, message-reply',
  'case-note': 'case-note',
  email_thread: 'email_thread',
  text_messages: 'text_message_reply',
  task: 'task',
  invoice: 'invoice',
  payment_request: 'payment_request',
};
